export const styles = {
  userIdContainer: {
    margin: 8,
    bgcolor: "secondary.light",
    height: 48,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: 1,
    borderColor: "primary.light",
  },
  deleteButton: {
    marginRight: "auto",
    color: "warning.dark",
    "&:hover": {
      bgcolor: "warning.light",
    },
  },
};
